import { jsx } from "react/jsx-runtime";
import { SUPPORTED_IMAGE_FORMATS } from "@seek/image-service-types";
import get from "lodash/get.js";
import { input } from "./FileUploader.css.mjs";
const FileUploader = ({
  onFileSelected,
  dataTestId,
  allowMultiple = false
}) => {
  const onChange = (e) => {
    const files = Array.from(get(e, "target.files", []));
    if (allowMultiple) {
      onFileSelected(files);
    }
    if (!allowMultiple && files.length > 0) {
      const image = files[0];
      onFileSelected(image);
    }
    e.target.value = "";
  };
  return /* @__PURE__ */ jsx(
    "input",
    {
      type: "file",
      title: "",
      accept: `.${SUPPORTED_IMAGE_FORMATS.join(",.")}`,
      className: input,
      "data-testid": dataTestId,
      onChange,
      multiple: allowMultiple
    }
  );
};
export {
  FileUploader
};
